import { BaseApi } from '@/main/baseApi';

import {
	MODULE_API, NAME, API_ND_SKLAD, REPORTS, DependentTableNames, PART_PRICING_LOG
} from './constants';

class NdCenikProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PART_PRICING_LOG:
				return `/${MODULE_API}/${NAME}/PricilingListSchema`;
			
			default:
				return `/${this.area}/${this.controller}/${tableName}Schema`;
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PART_PRICING_LOG:
				return `/${MODULE_API}/${NAME}/PricilingListRows`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Rows`;
		}
	}
	disponibilitaSpc(filter: any) {
		return this.fetch(`/${MODULE_API}/${API_ND_SKLAD}/DisponibilitaSpc`, filter);
	}
	addUpdatePrice(partNumber: any) {
		return this.post(`/${MODULE_API}/${NAME}/AddUpdatePrice?partNumber=${partNumber}`);
	}
	tisk(filter: any) {
		return this.fetch(`/${REPORTS}/${REPORTS}/Cenik`, filter);
	}
	entityByKey(filter: any) {
		return this.fetch(`/${MODULE_API}/${NAME}/Entity`, filter);
	}
	kdc(filter: any) {
		return this.fetch(`/${MODULE_API}/${NAME}/Kdc`, filter);
	}
	
	uploadParts(fileList: any,isAllWareHouse: boolean, provozovnaId: number|null , skladOzn: number|null) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${MODULE_API}/${NAME}/UploadParts?isAllWarehouse=${isAllWareHouse}&WorkShopId=${provozovnaId}&WareHouseId=${skladOzn}`,file);
	}
	async GetWarehouse(Ids: any) {    
        return this.fetch(`/DropdownList/GetWarehouse/`, { workshopId: Ids });      
    }
}
export const apiProvider = new NdCenikProvider(MODULE_API, NAME);